import plantImage from '@assets/images/plant.svg'
import { Card, Loading } from '@components'
import { formatDisplayText } from '@helpers'
import { useUpdatePlantActive } from '@hooks'
import { Plant } from '@types'
import type { FC } from 'react'

import StatusBadge from './StatusBadge/StatusBadge'

type PlantCardProp = {
  plant: Partial<Plant>;
  isAllowUpdateStatus?: boolean;
  index: number
  goToPlantDetail: (plantId: string) => void
}

const PlantCard: FC<PlantCardProp> = ({ plant, index, goToPlantDetail, isAllowUpdateStatus }) => {
  const { mutateAsync, isLoading } = useUpdatePlantActive()

  const handleStatusChange = async (plantId: string, status: boolean) => {
    try {
      await mutateAsync({ plantId, isActive: status })
    } catch {
      console.error('Failed to update plant status. Please try again.')
    }
  }

  const { plant_id, name = 'Plant Name' } = plant
  const displayName = formatDisplayText(name)
  const description = plant.description === '&nbsp;' ? '' : plant.description
  const displayDescription = formatDisplayText(description)
  const isActive = plant.is_active ?? true
  const img = plant.image_base64 || plantImage

  return (
    <div className='box' onClick={() => !isLoading && goToPlantDetail(plant_id)} key={`${plant_id}-card`}>
      <Card
        animationOrder={index + 1}
        content={
          <div className='content'>
            {isLoading && <Loading size={40} />}
            {isAllowUpdateStatus && <StatusBadge isActive={isActive} onStatusChange={(status) => handleStatusChange(plant_id, status)} />}
            <img className='img' src={img} alt={img} />
            <div className='name'>{displayName}</div>
            <div className='description'>{displayDescription}</div>
          </div>
        }
      />
    </div>
  )
}

export default PlantCard
